const reBankKontonummer = /^(\d{7}|\d{9,10})$/ // 7,9 or 10 digits

module.exports = function normalizeSvensktBankKontonummer(input) {
  const match = reBankKontonummer.exec(input.replace(/-|\s/g, ''))

  if (!match) return input

  return match[0]
}
